const TextInformation = () => {
  return (
    <div className="text-center md:text-left px-4 md:pl-32 py-8 md:py-12 flex flex-col gap-6 md:gap-10">
      <h1 className="text-white font-extrabold text-3xl sm:text-4xl md:text-6xl">
        ¡EXCLUSIVO PARA PROFESIONALES!
      </h1>

      <p className="text-white font-light text-lg sm:text-xl md:text-2xl">
        Completa tu registro y accede a nuestra plataforma con precios
        exclusivos y presentaciones diseñadas para profesionales.
      </p>

      <p className="text-white font-bold text-lg sm:text-xl md:text-2xl">
        Esta oportunidad es para ti
      </p>

      <div className="md:block text-white text-base sm:text-lg md:text-xl space-y-1">
        <p>🎁 33% de descuento en tu primera compra</p>
        <p>🔒 Registro gratuito</p>
        <p>📦 Acceso a todo el catálogo</p>
        <p>🧰 Fibra, resinas, flakes y más</p>
      </div>

      <p className="md:block text-white text-base sm:text-lg md:text-xl">
        Empieza a comprar como mayorista en nuestra plataforma
      </p>
    </div>
  );
};

export default TextInformation;
